import { render, staticRenderFns } from "./AmazonHome.vue?vue&type=template&id=17454223&scoped=true&"
import script from "./AmazonHome.vue?vue&type=script&lang=js&"
export * from "./AmazonHome.vue?vue&type=script&lang=js&"
import style0 from "./AmazonHome.vue?vue&type=style&index=0&id=17454223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17454223",
  null
  
)

export default component.exports